import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
import { RegisterComponent } from './auth/register/register.component';
import { ResetEmailSentComponent } from './auth/reset-email-sent/reset-email-sent.component';
import { ResetPasswordFormComponent } from './auth/reset-password-form/reset-password-form.component';
import { ResetPasswordSuccessfulComponent } from './auth/reset-password-successful/reset-password-successful.component';
import { SigninComponent } from './auth/signin/signin.component';
import { AccountComponent } from './dashboard/account/account.component';
import { ContactListComponent } from './dashboard/contact-list/contact-list.component';

import { CreateContactComponent } from './dashboard/create-contact/create-contact.component';
import { PaymentMethodComponent } from './dashboard/payment-method/payment-method.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HomeComponent } from './dashboard/home/home.component';
import { SendMoneyComponent } from './dashboard/send-money/send-money.component';
import { Step1Component } from './dashboard/send-money/step1/step1.component';
import { Step2Component } from './dashboard/send-money/step2/step2.component';
import { Step3Component } from './dashboard/send-money/step3/step3.component';
import { Step4Component } from './dashboard/send-money/step4/step4.component';
import { Step5Component } from './dashboard/send-money/step5/step5.component';
import { PayBillComponent } from './dashboard/pay-bill/pay-bill.component';
import { Biller1Component } from './dashboard/pay-bill/biller1/biller1.component'
import { Biller2Component } from './dashboard/pay-bill/biller2/biller2.component'
import { Biller3Component } from './dashboard/pay-bill/biller3/biller3.component'
import { Biller4Component } from './dashboard/pay-bill/biller4/biller4.component'


import { PurposeComponent } from './dashboard/send-money/purpose/purpose.component';
import { VerifyDocumentComponent } from './dashboard/verify-document/verify-document.component';
import { VerifyEmailComponent } from './dashboard/verify-email/verify-email.component';
import { VerifyPhonenumberComponent } from './dashboard/verify-phonenumber/verify-phonenumber.component';
import { HomepageComponent } from './homepage/homepage.component';
import { AuthGuardService } from './services/auth-guard.service';
import { UserVerifiedGuardService } from './services/user-verified-guard.service';
import { CaDocumentComponent } from './dashboard/ca-document/ca-document.component';
import { ManagePaymentMethodsComponent } from './dashboard/manage-payment-methods/manage-payment-methods.component';
import { ReferFriendComponent } from './dashboard/refer-friend/refer-friend.component';
import { DcintracSendSuccessfulComponent } from './dashboard/dcintrac-send-successful/dcintrac-send-successful.component';
import { SettingsComponent } from './dashboard/settings/settings.component';
import { RequestMoneyComponent } from './dashboard/request-money/request-money.component';
import { RequestStep1Component } from './dashboard/request-money/request-step1/request-step1.component';
import { RequestStep2Component } from './dashboard/request-money/request-step2/request-step2.component';
import { RequestStep3Component } from './dashboard/request-money/request-step3/request-step3.component';
import { RequestStep4Component } from './dashboard/request-money/request-step4/request-step4.component';
import { Biller5Component } from './dashboard/pay-bill/biller5/biller5.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { PayBillHomeComponent } from 'src/app/homepage/pay-bill-home/pay-bill-home.component'
import { AboutHomeComponent } from 'src/app/homepage/about-home/about-home.component'
import { ProfileComponent } from './dashboard/profile/profile.component';
import { FaqComponent } from './faq/faq.component';
import { RequestRecipientAddFormComponent } from './dashboard/request-recipient-add-form/request-recipient-add-form.component'
import { CadToInrComponent } from './homepage/cad-to-inr/cad-to-inr.component';
import { CadToNgnComponent } from './homepage/cad-to-ngn/cad-to-ngn.component';
import { CadToKesComponent } from './homepage/cad-to-kes/cad-to-kes.component';
import { CadToGhsComponent } from './homepage/cad-to-ghs/cad-to-ghs.component';
import { CadToXofComponent } from './homepage/cad-to-xof/cad-to-xof.component';
import { CadToPhpComponent } from './homepage/cad-to-php/cad-to-php.component';
import { CadToZarComponent } from './homepage/cad-to-zar/cad-to-zar.component';
import { UsdToInrComponent } from './homepage/usd-to-inr/usd-to-inr.component';
import { UsdToKesComponent } from './homepage/usd-to-kes/usd-to-kes.component';
import { UsdToNgnComponent } from './homepage/usd-to-ngn/usd-to-ngn.component';
import { UsdToGhsComponent } from './homepage/usd-to-ghs/usd-to-ghs.component';
import { UpgradeTierComponent } from './dashboard/upgrade-tier/upgrade-tier.component';
import { MobileVerifiedGuardService } from './services/mobile-verified-guard.service'
import { CustomLocationsComponent } from './custom-locations/custom-locations.component';
import { Step6Component } from './dashboard/send-money/step6/step6.component';
// import { CadToGbpComponent } from './homepage/cad-to-gbp/cad-to-gbp.component'
// import {CadToEurComponent} from './homepage/cad-to-eur/cad-to-eur.component'

const routes: Routes = [
  { path: "signin", component: SigninComponent },
  { path: "register", component: RegisterComponent },
  { path: "forget-password", component: ForgetPasswordComponent },
  { path: "reset-email-sent", component: ResetEmailSentComponent },
  { path: "terms-and-conditions", component: TermsAndConditionsComponent },
  { path: "frequently-asked-questions", component: FaqComponent },
  { path: "reset-password", component: ResetPasswordFormComponent },
  { path: "reset-password-successful", component: ResetPasswordSuccessfulComponent },
  { path: "verify-email", component: VerifyEmailComponent, canActivate: [AuthGuardService] },
  { path: "pay-bills", component: PayBillHomeComponent },
  { path: "about", component: AboutHomeComponent },
  { path: "locations", component: CustomLocationsComponent },
  { path: "", component: HomepageComponent },
  { path: "cad-to-inr", component: CadToInrComponent },
  { path: "cad-to-ngn", component: CadToNgnComponent },
  { path: "cad-to-kes", component: CadToKesComponent },
  { path: "cad-to-ghs", component: CadToGhsComponent },
  { path: "cad-to-xof", component: CadToXofComponent },
  { path: "cad-to-php", component: CadToPhpComponent },
  { path: "cad-to-zar", component: CadToZarComponent },
  // {path:"usd-to-inr",component:UsdToInrComponent},
  // {path:"usd-to-kes",component:UsdToKesComponent},
  // {path:"usd-to-ngn",component:UsdToNgnComponent},
  // {path:"usd-to-ghs",component:UsdToGhsComponent},
  // {path:"cad-to-gbp",component:CadToGbpComponent},
  // {path:"cad-to-eur",component:CadToEurComponent},
  {
    path: "", component: DashboardComponent, canActivate: [AuthGuardService], children: [
      { path: "dashboard", component: HomeComponent },
      { path: "verify-document", component: VerifyDocumentComponent },
      { path: "settings", component: SettingsComponent },
      { path: "profile", component: ProfileComponent },
      {
        path: "request-money", component: RequestMoneyComponent, canActivate: [UserVerifiedGuardService], children: [
          { path: "", component: RequestStep1Component },
          { path: "step1", component: RequestStep1Component },
          { path: "step2", component: RequestStep2Component },
          { path: "step3", component: RequestStep3Component },
          { path: "step4", component: RequestStep4Component },
        ]
      },
      { path: 'add-request-recipient', component: RequestRecipientAddFormComponent },
      /* {path:"verify-phonenumber",component:VerifyPhonenumberComponent}, */
      { path: "contact-list", component: ContactListComponent, canActivate: [UserVerifiedGuardService] },
      { path: "account", component: AccountComponent },
      { path: "payment-method", component: PaymentMethodComponent, canActivate: [UserVerifiedGuardService] },
      { path: "manage-payment-methods", component: ManagePaymentMethodsComponent, canActivate: [UserVerifiedGuardService] },
      { path: "upgrade-tier", component: UpgradeTierComponent, canActivate: [UserVerifiedGuardService] },
      { path: "create-contact", component: CreateContactComponent, canActivate: [UserVerifiedGuardService] },
      { path: "upload-document", component: CaDocumentComponent, canActivate: [MobileVerifiedGuardService] },
      { path: "refer", component: ReferFriendComponent },
      { path: "dcinfra", component: DcintracSendSuccessfulComponent },
      {
        path: "send-money", component: SendMoneyComponent, canActivate: [MobileVerifiedGuardService], children: [
          { path: "", component: Step1Component },
          { path: "step1", component: Step1Component },
          { path: "step2", component: Step2Component },
          { path: "step3", component: Step3Component },
          { path: "step4", component: Step4Component },
          { path: "step5", component: Step5Component },
          { path: "step5/:trans_key", component: Step5Component },
          { path: "step6/:trans_key", component: Step6Component },
        ]
      },
      {
        path: "pay-bill", component: PayBillComponent, canActivate: [MobileVerifiedGuardService], children: [
          { path: "", component: Biller1Component },
          { path: "biller1", component: Biller1Component },
          { path: "biller2", component: Biller2Component },
          { path: 'biller3', component: Biller3Component },
          { path: 'biller4', component: Biller4Component },
          { path: 'biller5', component: Biller5Component },
          { path: "biller5/:trans_key", component: Biller5Component },
          { path: "biller6/:trans_key", component: Step6Component },

        ]
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
